export * from "./NewTabLink";
